import type { GetAssessmentAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAssessmentAuditByIdArgs = {
  id: string;
};

export const useGetAssessmentAuditById = createQueryHook<
  UseGetAssessmentAuditByIdArgs,
  GetAssessmentAuditByIdQuery['assessment_audit'],
  GetAssessmentAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getAssessmentAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ assessment_audit: data }),
  graphqlDocument: GetAssessmentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
